import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  determineIfMagazine,
  determineMagazineIssueMonth,
  determineMagazineIssueNumber
} from '../../../../utils/tag_category_util';
import MagazineAttribution from '../../magazine_attribution/magazine_attribution';
import Author from './author';
import NewsletterSignup from '../../newsletter-signup/newsletter-signup';

export default class Footer extends Component {
  determineNewsletter(categories, currentSite) {
    if (!Array.isArray(categories)) return null;

    const isLeadership = !!categories.filter(cat => cat.slug === 'leadership')
      .length;
    const primaryNewsletter = isLeadership ? 'leadership' : currentSite;

    return {
      primary: primaryNewsletter,
      newsletters: [
        { list: primaryNewsletter, default: true },
        { list: 'events', default: true }
      ]
    };
  }

  render() {
    const {
      post,
      isLongPost,
      hasNewsletter,
      bylineAttribution,
      site,
      env
    } = this.props;
    const { tags, categories, author } = post;
    const hasAuthor = isLongPost && !bylineAttribution;

    return (
      <footer className="post__footer">
        {determineIfMagazine(categories)
          ? <MagazineAttribution
              issueMonth={determineMagazineIssueMonth(tags)}
              issueNumber={determineMagazineIssueNumber(tags)}
              currentSite={site}
              env={env}
            />
          : ''}
        {hasAuthor ? <Author modifier="post" {...author} /> : ''}
        {hasNewsletter
          ? <NewsletterSignup
              modifier="post"
              {...this.determineNewsletter(categories, site)}
            />
          : ''}
      </footer>
    );
  }
}

Footer.propTypes = {
  post: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    author: PropTypes.shape({}).isRequired
  }).isRequired,
  site: PropTypes.string.isRequired,
  env: PropTypes.string.isRequired,
  bylineAttribution: PropTypes.string.isRequired,
  isLongPost: PropTypes.bool.isRequired,
  hasNewsletter: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/post/content/footer.js